import React, { useState } from 'react'
import AuthorityProjects from './Tabs/AuthorityProjects'
import {AllProjects, CompletedProject, Ongoing} from '../Projects/Tabs/AllProjects'
import AuthorityOngoingProject from './Tabs/AuthorityOngoingProject';


const CompletedProjects = () => {
    const [toggleState, setToggleState] = useState(1);

  return (
        <div className='max-xl:py-10 relative flex items-start justify-center  pb-0'>
            <div className='max-sm:px-0 w-full flex flex-col items-center gap-12'>
            <div className='w-[100%] md:w-[60%] overflow-x-scroll  md:pr-4 rounded-full'>
            <div className="overflow-x-scroll max-sm:justify-start justify-center items-center flex gap-4 w-full md:w-auto">
                    {/* <button
                        className={
                        toggleState === 1
                            ? "home-tabs home-active-tabs"
                            : "home-tabs"
                        }
                        onClick={() => setToggleState(1)}
                    >
                        All Projects
                    </button> */}
                     <button
                        className={
                        toggleState === 1
                            ? "home-tabs home-active-tabs"
                            : "home-tabs bg-gray-100 rounded-full text-gray-900"
                        }
                        onClick={() => setToggleState(1)}
                    >
                        OnGoing Project
                    </button>
                    <button
                        className={
                        toggleState === 2
                            ? "home-tabs home-active-tabs"
                            : "home-tabs bg-gray-100 rounded-full text-gray-900"
                        }
                        onClick={() => setToggleState(2)}
                    >
                        Completed Project 
                    </button>
                   
                   
                    </div>
                </div>
                <div className='filterservicebgright'></div>
                <div className='filterservicebgleft !top-[720px]'></div>
                <div className="w-full max-sm:flex-nowrap">
                    {/* {toggleState === 1 ? <AuthorityProjects data={AllProjects}/> : null} */}
                    {toggleState === 1 ? <AuthorityOngoingProject data={Ongoing} /> : null}
                    {toggleState === 2 ? <AuthorityProjects data={CompletedProject} /> : null}
                   
                </div>
            </div>
        </div>
        
    )
}

export default CompletedProjects